import { jsx as _jsx } from "preact/jsx-runtime";
export default function FormError({ children }) {
    return (_jsx("div", { className: "form__error", children: children }));
}
